import React, {
  ReactCild,
  ReactFragment,
  RefObject,
  useMemo,
  useState,
} from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

// 툴바 포맷(여기에다 추가안하고 커스텀에만 추가하면 ui는 추가되나 실행은 안됨 )
const formats = [
  "font",
  "header",
  "bold",
  "italic",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "align",
  "color",
  "background",
  "size",
  "h1",
  "image",
  "video",
  "underline",
  "width",
];

// 툴바 커스텀
export const CustomToolbar = () => (
  <div id="toolbar">
    <span className="ql-formats">
      <select className="ql-size" defaultValue="medium">
        <option value="small">Small</option>
        <option value="medium">Medium</option>
        <option value="large">Large</option>
        <option value="huge">Huge</option>
      </select>
      <select className="ql-header">
        <option value="1">Header 1</option>
        <option value="2">Header 2</option>
        <option value="3">Header 3</option>
        <option value="4">Header 4</option>
        <option value="5">Header 5</option>
        <option value="6">Header 6</option>
      </select>
    </span>
    <span className="ql-formats">
      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
      <button className="ql-strike" />
      <button className="ql-blockquote" />
    </span>
    <span className="ql-formats">
      <select className="ql-color" />
      <select className="ql-background" />
    </span>
    <span className="ql-formats">
      <button className="ql-image" />
      <button className="ql-video" />
    </span>
    <span className="ql-formats">
      <button className="ql-clean" />
    </span>
  </div>
);

export function EditorForm_quil({ onChange }) {
  const W100 = { width: "100%" };
  const [values, setValues] = useState();

  // 파일 업로드 시 이미지 처리

  //content 값 넣기
  const handleChange = (value) => {
    if (onChange) {
      onChange(value);
    }
  };

  const modules = useMemo(() => {
    return {
      toolbar: {
        container: "#toolbar",
      },
    };
  }, []);

  return (
    <div style={W100}>
      <CustomToolbar />
      <ReactQuill
        theme="snow"
        modules={modules}
        formats={formats}
        onChange={handleChange}
        placeholder="Please enter content. Inappropriate content such as abusive language, defamation, or promotional material may be automatically removed without notice."
      />
    </div>
  );
}
